// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import {
  MobileListItem,
  MobileListWrapper,
} from '../../utils/Styles/MobileListItem';
import { TagForm } from '../../forms/TagForm';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const TagsListMobile = ({ content, handleTagChange }) => {
  return (
    <MobileListWrapper>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {content.map(tag => (
        <MobileListItem key={tag.name}>
          <div>
            <h5 className='title'>{tag.name}</h5>
          </div>
          <div>
            <TagForm
              // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
              // @ts-ignore
              handleTagChange={handleTagChange}
              changeType={handleTagChange}
              tag={tag}
              width='150px'
            />
          </div>
        </MobileListItem>
      ))}
    </MobileListWrapper>
  );
};

export default TagsListMobile;
